import React from "react";
import { Trash2, Plus } from "lucide-react";
import { Input } from "../ui/input";
import { Label } from "../ui/label";

const ThinkingForm = ({ data, onChange, submitted }) => {
  const handleChange = (index, field, value) => {
    onChange((prev) => {
      const newData = [...prev];
      newData[index] = { ...newData[index], [field]: value };
      return newData;
    });
  };

  const addItem = () => {
    onChange((prev) => [...prev, { title: "", description: "" }]);
  };

  const removeItem = (index) => {
    onChange((prev) => prev.filter((_, i) => i !== index));
  };

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <Label className="text-lg font-bold">Thinking Points <span className="text-red-500">*</span></Label>
        <button
          type="button"
          onClick={addItem}
          className="flex items-center gap-1 bg-primary/10 text-primary px-3 py-1.5 rounded-lg text-sm font-semibold hover:bg-primary/20 transition-all"
        >
          <Plus size={16} /> Add Point
        </button>
      </div>

      {data.length === 0 && submitted && (
        <p className="text-xs text-red-500 font-medium">Please add at least one thinking point.</p>
      )}

      <div className="grid grid-cols-1 gap-4">
        {data.map((item, index) => (
          <div
            key={index}
            className={`bg-white p-6 rounded-2xl border relative group shadow-sm transition-all ${submitted && (!item.title || !item.description) ? "border-red-500 shadow-red-50" : "border-slate-200"}`}
          >
            <button
              type="button"
              onClick={() => removeItem(index)}
              className="absolute top-4 right-4 text-red-400 hover:text-red-600 transition-colors"
            >
              <Trash2 size={18} />
            </button>
            <div className="space-y-4">
              <div className="space-y-2 pr-8">
                <Label>Title <span className="text-red-500">*</span></Label>
                <Input
                  value={item.title}
                  className={`font-semibold ${(!item.title && submitted) ? "border-red-500" : ""}`}
                  onChange={(e) => handleChange(index, "title", e.target.value)}
                  placeholder="e.g. The Challenge"
                />
              </div>
              <div className="space-y-2">
                <Label>Description <span className="text-red-500">*</span></Label>
                <textarea
                  className={`w-full h-24 px-4 py-2 rounded-xl border focus:ring-2 focus:ring-primary/20 focus:border-primary outline-none transition-all text-sm ${(!item.description && submitted) ? "border-red-500" : "border-slate-200"}`}
                  value={item.description}
                  onChange={(e) =>
                    handleChange(index, "description", e.target.value)
                  }
                  placeholder="Describe your thinking process..."
                />
              </div>
            </div>
          </div>
        ))}
      </div>

      {data.length > 0 && (
        <button
          type="button"
          onClick={addItem}
          className="w-full py-4 border-2 border-dashed border-slate-200 rounded-2xl text-slate-400 hover:border-primary/50 hover:text-primary transition-all flex items-center justify-center gap-2 font-medium"
        >
          <Plus size={20} /> Add Another Point
        </button>
      )}
    </div>
  );
};

export default ThinkingForm;
